<template>
    <v-dialog v-model="gmgmwdialog">
        <v-card>
            <v-container fluid>
                <v-row no-gutters>
                    <v-col
                        cols="12"
                        md="4"
                        sm="4"
                    >
                        <h1>GM-GMW Purchase</h1>
                    </v-col>
                    
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn color="purple" @click="importpurchase()" >
                            Import Selected
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredBills"
                    item-value="billid"
                    return-object
                    show-select
                >
                <template v-slot:thead>
                    <tr>
                        <td></td>
                        <td>
                            <v-text-field v-model="billnosearch" class="ma-2" density="compact" placeholder="Bill No..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="billdatesearch" class="ma-2" density="compact" placeholder="Bill Date..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="partysearch" class="ma-2" density="compact" placeholder="Party..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="amountsearch" class="ma-2" density="compact" placeholder="Greater Than" hide-details></v-text-field>
                        </td>
                    </tr>
                </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
    import BillService from '@/services/BillService'
    import PurchaseService from '@/services/PurchaseService'
    import BatchService from '@/services/BatchService'

    const props = defineProps(['showGmGmwForm'])
    const emit = defineEmits(['closegmgmwdialog'])

    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')

    var gmwbills = ref([])
    var gmgmwdialog = ref(props.showGmGmwForm)

    var billdatesearch = ref('')
    var billnosearch = ref('')
    var partysearch = ref('')
    var amountsearch = ref('')
    var batches = ref([])

    var headers = ref([
        {
          title: 'Bill No',
          align: 'start',
          sortable: true,
          key: 'billno',
        },
        { title: 'Bill Date', key: 'billdate' },
        { title: 'Partyname', key: 'bills_partyname' },
        { title: 'Amount', key: 'billamount' },
    ])

    var selected= ref([])

    onBeforeMount(async () => {
        await getgmwbils()
        await getbatches()
    })

    async function getbatches(){
        try{
            var batch = (await BatchService.getallgmw()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        batches.value = batch
        return batch
    }

    async function getgmwbils(){
        try{
            var bills = (await BillService.getallgmwbills()).data
            gmwbills.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return bills
    }

    async function importpurchase(){
        for (let i = 0; i < selected.value.length; i++){
            var bill = selected.value[i]

            var billtopass = {
                ps_vname: 'G.M.PHARMACEUTICALS',
                ps_chno: bill.billno,
                ps_chdate: bill.billdate,
                ps_chbillno: bill.billno,
                ps_taxable: bill.total,
                ps_igst: bill.bills_igst,
                ps_cgst: bill.bills_cgst,
                ps_sgst: bill.bills_sgst,
                ps_billamount: bill.billamount
            }

            var puritems = []

            for (let j = 0; j < bill.productsales.length; j++){
                var sellitem = bill.productsales[j]
                var item = {
                    pi_billno: sellitem.billno,
                    pi_billdate: sellitem.billdate,
                    pi_vname: 'G.M.PHARMACEUTICALS',
                    pi_itemid: await getitemid(sellitem.productname,sellitem.batchno ),
                    pi_hsncode: sellitem.hsncode,
                    pi_productname: sellitem.productname,
                    pi_batchno: sellitem.batchno,
                    pi_expdate: sellitem.expdate,
                    pi_mrp: sellitem.mrp,
                    pi_rate: sellitem.rate,
                    pi_qty: sellitem.qty,
                    pi_free: sellitem.free,
                    pi_total: sellitem.total,
                    pi_discount: sellitem.discount,
                    pi_igstrate: sellitem.igst_rate,
                    pi_igstamount: sellitem.igst_amount,
                    pi_cgstrate: sellitem.cgst_rate,
                    pi_cgstamount: sellitem.sgst_amount,
                    pi_sgstrate: sellitem.sgst_rate,
                    pi_sgstamount: sellitem.sgst_amount,
                }

                puritems.push(item)
            }

            billtopass.puritems = puritems

            try{
                await PurchaseService.creategmw(billtopass)
            }catch(err){
                showMessage.value = true
                msgStatus.value = 'error'
                msg.value = err.response.data.error
            }
        }

        gmgmwdialog.value = false
    }

    async function getitemid(productname,batchno){
        var itemid = 0
        var item = batches.value.filter(function(el){
            return el.productname == productname &&
                    el.batchno == batchno
            })
            if(item.length > 0){
                itemid = item[0].itemid
            }
        return itemid
    }

    watch(gmgmwdialog, async(val)=>{
        if(gmgmwdialog.value===false){
            //console.log("Form is closed")
            emit('closegmgwdialog')
        }
    })

    function filterBillno(item){
        return item.billno.toLowerCase().includes(billnosearch.value.toLowerCase())
    }
    function filterBilldate(item){
        return item.billdate.toLowerCase().includes(billdatesearch.value.toLowerCase())
    }

    function filterParty(item){
        return item.bills_partyname.toLowerCase().includes(partysearch.value.toLowerCase())
    }

    function filterAmount(item){
        return item.billamount >= amountsearch.value
    }

    const filteredBills = computed(() => {
        var conditions = []

        if(billnosearch.value){
            conditions.push(filterBillno)
        }

        if(billdatesearch.value){
            conditions.push(filterBilldate)
        }

        if(partysearch.value){
            conditions.push(filterParty)
        }

        if(amountsearch.value){
            conditions.push(filterAmount)
        }

        if(conditions.length > 0){
            return gmwbills.value.filter((bill) => {
                return conditions.every((condition) => {
                    return condition(bill)
                })
            })
        }

        return gmwbills.value
    })

</script>